import get from "get-value";
import PropTypes from "prop-types";
import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import set from "set-value";
import { clearAlerts } from "../../../actions/alertsActions";
import {
    fetchAseInternalTicketSgInfo,
    resetAseInternalTicket,
    resetAseInternalTicketSgInfo,
    saveAseInternalTicket,
} from "../../../actions/ase/actionAseInternalTicket";
import { createReqFields } from "../../../constants/aseInternalTicketRequiredFields";
import { createTechnicalBulletinRights } from "../../../constants/aseInternalTicketRights";
import { ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET_FORM } from "../../../constants/formConstants";
import formTypeMessages from "../../../intl/common/formTypeMessages";
import { scrollContentWrapperToTop } from "../../../utils/utils";
import PageHeader from "../../common/PageHeader";
import checkRoles from "../../common/roleChecker/RoleChecker";
import ValidFormattedMessage from "../../common/ValidFormattedMessage";
import Loader from "../../Loader";
import {
    initNewAseInternalTicket,
    transformNewInternalTicketForSave,
} from "../Utils";
import InternalTechnicalBulletinTicketMasterForm from "./forms/InternalTechnicalBulletinTicketMasterForm";
import UploadingAseInternalTicketAttachments from "./UploadingAseInternalTicketAttachments";

class NewAseInternalTechnicalBulletinTicketPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ticketSubmittedAndShouldRedirect: false };
    }

    componentDidMount() {
        const {
            clearAlerts,
            fetchAseInternalTicketSgInfo,
            resetAseInternalTicket,
            resetAseInternalTicketSgInfo,
            userDetail,
        } = this.props;
        clearAlerts();
        resetAseInternalTicket();
        resetAseInternalTicketSgInfo();
        if (
            get(userDetail, "roles.ASE.sgEditor.sgPermission", []).length === 1
        ) {
            fetchAseInternalTicketSgInfo(
                get(userDetail, "roles.ASE.sgEditor.sgPermission.0.id", ""),
            );
        }

        scrollContentWrapperToTop();
    }

    handleSubmit(values) {
        const { userDetail, saveAseInternalTicket } = this.props;

        const editorSolutionGroups = get(
            userDetail,
            "roles.ASE.sgEditor.sgPermission",
        );
        const dataForSend = transformNewInternalTicketForSave(
            values.newValues,
            editorSolutionGroups,
        );

        saveAseInternalTicket(dataForSend);
        this.setState({ ticketSubmittedAndShouldRedirect: true });
    }

    render() {
        const {
            formType,
            ticketData,
            userDetail,
            group,
            attachmentsData,
            location: { initData },
        } = this.props;

        if (
            Array.isArray(attachmentsData.attachmentsForUpload) &&
            attachmentsData.attachmentsForUpload.length > 0
        ) {
            return (
                <UploadingAseInternalTicketAttachments
                    attachments={attachmentsData.attachmentsForUpload}
                    attachmentsUrl={ticketData.newAttachments}
                    correlationId={ticketData.correlationId}
                    isAttachmentUploading={
                        attachmentsData.isTicketAttachmentUploading
                    }
                    formType={formType}
                />
            );
        }

        if (
            this.state.ticketSubmittedAndShouldRedirect &&
            !ticketData.isTicketCreating &&
            !ticketData.isTicketLoading &&
            get(ticketData, "ticket.uuid", { default: false })
        ) {
            return (
                <Redirect
                    to={{
                        pathname: `/ase/internalTechnicalBulletinTicket/view/${ticketData.ticket.uuid}`,
                        redirectedAfterUpdate: true,
                    }}
                />
            );
        }

        if (
            !formType ||
            this.state.ticketSubmittedAndShouldRedirect ||
            ticketData.correlationId
        ) {
            return <Loader />;
        }

        const initialValues = initNewAseInternalTicket(userDetail, initData);
        const requiredFields =
            createReqFields[createReqFields[group] ? group : "DEFAULT"][
                formType
            ];

        return (
            <div id="ticketPrint" className="container-fluid">
                <PageHeader
                    title={
                        <ValidFormattedMessage
                            message={formType}
                            intlMessages={formTypeMessages}
                        />
                    }
                />
                <div>
                    <InternalTechnicalBulletinTicketMasterForm
                        form={formType}
                        initialValues={set(
                            initialValues,
                            "ticketSection.formType",
                            ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET_FORM,
                        )}
                        userRights={createTechnicalBulletinRights}
                        reqFields={requiredFields}
                        handleSubmit={this.handleSubmit.bind(this)}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    userDetail: state.profile.userDetail,
    group: state.profile.userDetail.group,
    ticketData: state.aseInternalTicket,
    attachmentsData: state.aseInternalTicketAttachment,
});

NewAseInternalTechnicalBulletinTicketPage.propTypes = {
    clearAlerts: PropTypes.func.isRequired,
    userDetail: PropTypes.object.isRequired,
    formType: PropTypes.string.isRequired,
    saveAseInternalTicket: PropTypes.func.isRequired,
    ticketData: PropTypes.object.isRequired,
    attachmentsData: PropTypes.object.isRequired,
};

export default checkRoles(
    withRouter(
        connect(mapStateToProps, {
            clearAlerts,
            saveAseInternalTicket,
            resetAseInternalTicket,
            resetAseInternalTicketSgInfo,
            fetchAseInternalTicketSgInfo,
        })(injectIntl(NewAseInternalTechnicalBulletinTicketPage)),
    ),
    ["AS_SG_EDITOR"],
);

